// Cola local de check-ins pendientes para cuando se cae la conexión en la puerta.
// Solo transporte: el API sigue siendo quien valida y deduplica (POST /cccd/attendance/checkin
// responde 409 si el boleto ya tenía entrada ese día, lo que hace seguro reintentar).

export type QueuedCheckin = {
  /** Clave de deduplicación: boleto + día. Un mismo QR escaneado dos veces no se encola dos veces. */
  key: string
  qrToken?: string
  attendeeId?: string
  eventDate: string
  method: "qr_scan" | "document_lookup"
  wristbandGiven: boolean
  /** Nombre legible para mostrar en la cola (el QR offline solo conoce el token). */
  label: string
  queuedAt: number
}

const STORAGE_KEY = "cccd-checkin-queue"

export function readQueue(): QueuedCheckin[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    const parsed = raw ? JSON.parse(raw) : []
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}

function writeQueue(queue: QueuedCheckin[]): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(queue))
  } catch {
    // Almacenamiento no disponible (modo privado, cuota): la cola vive solo en memoria de la página.
  }
}

export function queueKey(ticketRef: string, eventDate: string): string {
  return `${ticketRef}:${eventDate}`
}

/** Devuelve false si el boleto ya estaba en cola para ese día. */
export function enqueueCheckin(item: Omit<QueuedCheckin, "queuedAt">): boolean {
  const queue = readQueue()
  if (queue.some((q) => q.key === item.key)) return false
  writeQueue([...queue, { ...item, queuedAt: Date.now() }])
  return true
}

export function removeFromQueue(key: string): void {
  writeQueue(readQueue().filter((q) => q.key !== key))
}

/** Una petición que ni siquiera obtuvo respuesta HTTP (sin red, timeout, DNS). */
export function isNetworkError(err: unknown): boolean {
  if (typeof err !== "object" || err === null) return false
  const response = (err as { response?: unknown }).response
  return !response
}
